module.exports = __webpack_public_path__ + "static/media/triple-yin.cffd01b2.svg";